import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Price = styled(Typography).attrs(({ isExpired }) => ({
  variant: isExpired ? 'h4' : 'h2',
  customAs: 'p',
}))`
  margin: 0;
  color: ${({ isSale, isMoment }) => {
    if (isSale) return getThemeColor('hue.red');

    if (isMoment) return getThemeColor('hue.green');

    return 'inherit';
  }};
`;
